<template>
  <div class="body_bottom">
    <div class="container">
      <div class="box">
        <div class="bottom_logo wow fadeInLeft" data-wow-delay=".2s">
          <ul>
            <li class="body_bottom-logo"><img src="~@/assets/image/logo.png" border="0"></li>
            <li>地址：江苏省常州市武进区长虹东路333号<br />手机：18861118636<br />邮箱：<a
                href="mailto:sales@guangshapf.com">sales02@lintel.com.cn</a></li>
          </ul>
        </div>
        <div class="bottom_item wow fadeInLeft" data-wow-delay=".4s">
          <h2>我们的服务</h2>
          <span><router-link :to="{ name: 'customizedservice' }">中小型环保展台方案在线定制</router-link></span>
          <span><router-link :to="{ name: 'aboutdetail', params: { goodsId: 38 } }">中小型环保展台标准套餐在线订购</router-link></span>
          <span><router-link :to="{ name: 'aboutdetail', params: { goodsId: 39 } }">中小企业参展相关产品和服务</router-link></span>
        </div>


        <div class="bottom_right box wow fadeInRight" data-wow-delay="1s">

          <div class="bottom_wz">
            <h3>0519-8870 2888</h3>
            <div class="flex">
              <div class="dyimg">
                <img src="~@/assets/image/dy.png">
                <div>抖音官方账号</div>
              </div>
              <div class="xian"></div>
              <div class="hsimg">
                <img src="~@/assets/image/hs.png">
                <div>小红书官方账号</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom_copyright wow fadeInUp" data-wow-delay="1.2s">CopyRight © 2022 常州灵特尔轻便展示系统有限公司 版权所有</div>
    </div>
  </div>
</template>
<script>

import { mapState } from 'vuex'
export default {
  name: 'Footer',
  data() {
    return {
      telphone: '',
      worktime: '',
      settings: [],
      bottomList: [],
      links: [],
      erCode: '',
      isShow: false,
      codeImg: ''
    }
  },
  computed: {
    ...mapState({
      shopMenu: state => state.shopMenu,
    }),
  },
  watch: {
    shopMenu(newVal, oldVal) {
      let shopMenu = newVal
      this.setInfo(shopMenu)
    },
  },
  components: {

  },
  methods: {
    showChat() {
      // _AIHECONG("showChat"); //合从

    },
    setInfo(shopMenu) {
      // console.log('shopMenu', shopMenu)
      let settings = shopMenu.settings
      this.settings = settings
      let bottomList = shopMenu.menu.bottom
      this.bottomList = bottomList
      let links = shopMenu.link
      this.links = links
      this.settings.find(item => {
        if (item.k == 'phone') {
          this.telphone = item.val
        }
        if (item.k == 'business') {
          this.worktime = item.val
        }
        if (item.k == 'app_image') {
          this.codeImg = item.val
        }
      })
    },
    showCode(type) {
      // console.log(type);
      if (type == 1) {
        this.isShow = true;
      } else {
        this.isShow = false;
      }
    }
  },
  mounted() {
    if (this.shopMenu.settings) {
      this.setInfo(this.shopMenu)
    }
  },
}
</script>
<style lang="scss" scoped>
.body_bottom-logo {
  margin-bottom: 10px;
  img {
    max-height: 60px;
  }
}

.bottom_right {
  margin-left: auto;
}
</style>